import React, { useState } from 'react';

import { useFormSelector } from '../../../custom-hooks';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { useWindowDimensions } from '../../../custom-hooks/useWindowDimensions';
import { getUITA } from '../../../utils/commonUtils';
import Accordion from '../../components/Accordion';
import { FORM_MODEL_ATTRIBUTES, SS_CONTROL_TYPE } from '../../constants/form-manager.constants';
import DynamicField from '../../DynamicField';
import {
  getEntityTranslation,
  getEvaluatedExpression,
} from '../../selectors/form-manager.selectors';
import {
  getRepeatingPanelUntranslatedTitle,
  getRowTitle,
} from '../../utils/controls/ssRepeatingPanel.utils';
import { getIndexForControlsInsideTable } from '../../utils/form-manager.utils';

const RepeatingTableSection = ({
  id,
  row,
  entityName,
  panelIndex,
  childrenNodes,
  showHeader,
  disableDelete,
  viewOnly,
  isDetail,
  isParentlessTable,
  handleDelete,
  rowsLength,
  rowIndex = 0,
  hasPaddings = false,
}) => {
  const translateString = useTranslation();
  const { isMobileDevice } = useWindowDimensions();

  const [isCollapsed, setCollapsed] = useState(isMobileDevice);

  const gridArrIndex = getIndexForControlsInsideTable(
    panelIndex,
    isParentlessTable ? row.gridArrIndex : row.index,
    isParentlessTable
  );

  const evaluatedTitle = useFormSelector(getEvaluatedExpression, {
    id,
    index: gridArrIndex,
    entityName,
    isParentlessTable,
    prop: FORM_MODEL_ATTRIBUTES.ROW_TITLE,
  });

  const fallbackTitle = useFormSelector(getEntityTranslation, { id });
  const title = getRepeatingPanelUntranslatedTitle(evaluatedTitle, fallbackTitle);

  return (
    <Accordion
      isCollapsed={isCollapsed}
      showHeader={showHeader}
      controlType={`${SS_CONTROL_TYPE.REPEATING_PANEL}${hasPaddings ? '' : '|section'}`}
      title={getRowTitle(translateString(title), rowIndex, rowsLength)}
      onChange={() => setCollapsed(!isCollapsed)}
      onActionClick={!disableDelete && !isDetail ? () => handleDelete(row) : undefined}
      headerUiTa={getUITA('SSRepeatingTableSectionHeader', entityName)}
      autoScrollUpEnabled={isMobileDevice && isCollapsed}
    >
      <div ui-ta={getUITA('SSRepeatingTableSectionDetails', entityName)}>
        {childrenNodes.map((childId) => (
          <DynamicField
            id={childId}
            key={childId}
            index={gridArrIndex}
            isParentViewOnly={viewOnly}
            isDetail={isDetail}
          />
        ))}
      </div>
    </Accordion>
  );
};

export default React.memo(RepeatingTableSection);
